import Vue from 'vue'
import Router from 'vue-router'
import Custom from '@/views/Custom'
import ShopifyAuthCallback from '@/views/ShopifyAuthCallback.vue';
import test from '@/views/test.vue';

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'custom',
      component: Custom
    },
    {
      path: '/test',
      name: 'test',
      component: test
    },
    {
      path: '/shopify/auth/callback',
      name: 'shopify_auth_callback',
      component: ShopifyAuthCallback
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js